import { FC, useRef, useState } from "react";
import "./styles.scss";
import { PageShell } from "../PageShell";
import { useTranslation } from "../../../hooks/useTranslation";

// Served from the CDN (allow-listed in media-src in public/index.html's CSP); the small poster ships with the app.
const PARTNERSHIP_VIDEO_URL = "https://connectyidfile.nyc3.cdn.digitaloceanspaces.com/rebee.mp4";
const PARTNERSHIP_VIDEO_POSTER = "/videos/rebbe-poster.jpg";

export const PartnershipPage: FC = () => {
  const { p } = useTranslation("landing_partnership");
  const videoRef = useRef<HTMLVideoElement>(null);
  // Native controls only once playing: until then the poster carries one large
  // play button instead of a thin control bar across the Rebbe's image.
  const [started, setStarted] = useState(false);

  const play = () => {
    setStarted(true);
    videoRef.current?.play().catch(() => undefined);
  };

  return (
    <PageShell>
      <div className="landing-partnership-page">
        <h1 className="landing-partnership-page__heading">{p("heading")}</h1>

        <figure className="landing-partnership-page__media">
          <video
            ref={videoRef}
            src={PARTNERSHIP_VIDEO_URL}
            poster={PARTNERSHIP_VIDEO_POSTER}
            controls={started}
            playsInline
            preload="metadata"
            onPlay={() => setStarted(true)}
            className="landing-partnership-page__video"
          />
          {!started && (
            <button
              type="button"
              className="landing-partnership-page__play"
              onClick={play}
              aria-label={p("play_video")}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" />
              </svg>
            </button>
          )}
        </figure>

        <p className="landing-partnership-page__text">{p("p1")}</p>
        <p className="landing-partnership-page__text">{p("p2")}</p>
        <p className="landing-partnership-page__text">{p("p3")}</p>
        <p className="landing-partnership-page__text">{p("p4")}</p>

        <p className="landing-partnership-page__pullquote">{p("p5")}</p>
      </div>
    </PageShell>
  );
};
